<template>
    <div class="checkout-page">
        <div class="checkout-panel">
            <!-- 返回按钮 -->
            <button class="back-btn" @click="goBack" title="返回">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 12H5M12 19L5 12L12 5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
            </button>

            <!-- 可滚动内容区域 -->
            <div class="scrollable-content">
                <div v-if="loading" class="loading">
                    <div class="spinner"></div>
                    <p>
                        {{ $i18n.t("subscription.checkout_page_payment_order_loading_txt") }}
                    </p>
                </div>

                <div v-else-if="!order">
                    <PaymentMethod v-model="selectedPayment" />

                    <div class="price-display">
                        <div>
                            {{ $i18n.t("subscription.checkout_page_payment_amount") }}
                        </div>
                        <div class="price-amount">${{ productPrice }}</div>
                    </div>

                    <div class="personal-info">
                        <h3 class="section-title">
                            {{ $i18n.t("subscription.checkout_page_payment_check_subscription_info") }}
                        </h3>
                        <div class="product-title">{{ product.Name }}</div>
                        <ul class="feature-list">
                            <li v-for="feature in product.Description" :key="feature">{{ feature }}</li>
                        </ul>
                    </div>
                </div>

                <!-- <QRCodePayment v-else-if="order && !paymentCompleted" :CodeUrl="order.CodeUrl"
                    :OrderNo="order.OrderNo" :check-payment-api="checkPayment" :PayMethod="selectedPayment" @success="handlePaymentSuccess"
                    @timeout="handlePaymentTimeout" /> -->
                    
                <StripeWaitPayment v-else-if="sessionId" :CodeUrl="order.CodeUrl"
                    :OrderNo="order.OrderNo" :check-payment-api="checkPayment" :PayMethod="selectedPayment" @success="handlePaymentSuccess"
                    @timeout="handlePaymentTimeout" />
            </div>

            <!-- 固定在底部的确认区域 -->
            <div v-if="!loading && !order" class="fixed-bottom">
                <div class="confirm-section">
                    <div class="confirm-text">
                        <p>
                            {{ $i18n.t("subscription.checkout_page_payment_remind_txt") }}
                        </p>
                    </div>
                    <button class="confirm-btn" @click="confirmPurchase" :disabled="!selectedPayment">
                        {{ $i18n.t("subscription.checkout_page_payment_btn_pay") }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/plugins/i18n.js";
import { userKeys, wdConfigData } from "@/service/wd_app_config.js";
import PaymentMethod from '../components/paymentMethod.vue';
import QRCodePayment from '../components/qrCodePayment.vue';
import StripeWaitPayment from "../components/stripeWaitPayment.vue";
import { api_create_pay, create_checkout_session, api_query_order_status, subscriptionApi } from '../services/subscriptionApi.js';
import { mdiAccessPoint } from "@mdi/js";
import { PaymentType } from "@/store/modules/enums";

export default {
    name: 'CheckoutPage',
    components: {
        PaymentMethod,
        QRCodePayment,
        StripeWaitPayment
    },
    data() {
        return {
            loading: false,
            selectedPayment: PaymentType.STRIPE,
            productPrice: 0,
            product: {
                Id: null,
                Code: null,
                Name: null,
                Description: null,
                Features: [],
                Price: 0
            },
            order: null,
            paymentCompleted: false,
            sessionId: '',
        };
    },
    async mounted() {
        i18n.locale = wdConfigData.localLanguage
        await this.loadProductInfo();
    },
    methods: {
        async loadProductInfo() {
            try {
                this.product = this.$route.params.product;
                if (this.product) {
                    this.productPrice = this.product.Price;
                } else {
                    this.$router.push('/products');
                }
            } catch (error) {
                console.error('Failed to load product info:', error);
                this.$router.push('/products');
            }
        },
        goBack() {
            this.$router.push('/subscriptions?tab=buy-subscriptions');
        },
        async confirmPurchase() {
            this.loading = true;
            var user = JSON.parse(localStorage.getItem(userKeys.key_userObject))
            var corporationId = localStorage.getItem(userKeys.key_corporationId)
            var accessToken = localStorage.getItem(userKeys.key_corporationAccessToken)
            var params = {
                UserId: user.Id,
                CorporationId: corporationId,
                AccessToken: accessToken,
                ProductName: this.product.Name,
                PlanId: this.product.Id,
                Description: this.product.Name + this.product.Description.join("，"),
                Amount: this.product.Price * 7.13,
                ExpireTime: "",
                PaymentMethod: this.selectedPayment
            };
            var that = this;
            this.sessionId = "";
            if (this.selectedPayment == PaymentType.STRIPE) {
                // 根据product.name(转换小写后判断)选择对应的PriceId
                /**
                 * (test)plus-monthly:price_1SnKhCQ46oNJySZpwJQILYvP
                 * plus-monthly:price_1Smow8Q46oNJySZpBd4MAXQK
                 * plus-yearly:price_1Smox9Q46oNJySZpTdWrPo4A
                 * pro-monthly:price_1Smoy3Q46oNJySZpSmc1FkKv
                 * pro-yearly:price_1Smoz5Q46oNJySZpfjNrwT8m
                 */
                var productNameLower = this.product.Name.toLowerCase();
                switch (productNameLower) {
                    case "plus-monthly":
                        params.PriceId = "price_1Smow8Q46oNJySZpBd4MAXQK";  
                        break;
                    case "plus-yearly":
                        params.PriceId = "price_1Smox9Q46oNJySZpTdWrPo4A";
                        break;
                    case "pro-monthly":
                        params.PriceId = "price_1Smoy3Q46oNJySZpSmc1FkKv";
                        break;
                    case "pro-yearly":
                        params.PriceId = "price_1Smoz5Q46oNJySZpfjNrwT8m";
                        break;
                    default:
                        break;
                }
                // params.PriceId = "price_1SnKhCQ46oNJySZpwJQILYvP"
                params.Quantiy = 1
                
                // that.handleCreateSessionResponse();
                create_checkout_session(params).then(
                    (response) => {
                        that.handleCreateSessionResponse(response);
                    },
                    (error) => {
                        console.error(error);
                        that.isLoadingPrevPage = false;
                    }
                );
            } else {
                api_create_pay(params).then(
                    (response) => {
                        that.handleCreatePayResponse(response);
                    },
                    (error) => {
                        console.error(error);
                        that.isLoadingPrevPage = false;
                    }
                );
            }
        },
        handleCreatePayResponse(response) {
            if (response.data.Code === 0) {
                var qrCodeUrl = response.data.Result.CodeUrl;
                var orderNo = response.data.Result.OrderNo;
                this.order = {
                    CodeUrl: qrCodeUrl,
                    OrderNo: orderNo
                };
                this.loading = false;
            } else {
                this.loading = false;
                this.$message.error('订单创建失败，请重试');
            }
        },
        async handleCreateSessionResponse(response) {
            if (response.data.Code === 0) {
                this.sessionId = response.data.Result.sessionId;
                var publishableKey = response.data.Result.publishableKey;
                this.loading = false;
                this.order = {
                    CodeUrl: "",
                    OrderNo: response.data.Result.OrderNo
                };
                // 跳转到Stripe结账页面
                // Step 2: 动态加载 Stripe.js
                await this.loadStripeJs();

                if (!window.Stripe) {
                    console.error('Stripe.js 未加载');
                    this.loading = false;
                    return;
                }
                // 使用 Stripe.js 重定向到 Checkout 页面
                // this.sessionId = "cs_test_a1gFskf1oUnVLgQQv8rk0FabYeoc7wsuuEYHG4TWCbE8wCmLoivZSEnU4i";
                // const stripe = Stripe("pk_test_51S2nzLH7MgMU5sCWWurtHOsMElZa7mElIZ7NLv4ll3MGXAzF6bZuOUgbL31IOkUxhESeAZYCihGLOTs56QJKkFmT00yKAUxFiK");
                var publishableKey = publishableKey || "pk_live_51SMgVTQ46oNJySZpiGp4hAZnEVqmaOM4fUQE8NAjb7nTCjWFRGlaFh3idt7hKHTsOxnqompDwLZwYWsBpv3lsQwE00WYNUGAS9"
                const stripe = Stripe(publishableKey);
                const { error } = stripe.redirectToCheckout({ sessionId: this.sessionId });

                if (error) {
                    console.error('Stripe Checkout 错误:', error.message);
                }
            } else {
                this.loading = false;
                this.$message.error('订单创建失败，请重试');
            }
        },
        async loadStripeJs() {
            if (window.Stripe) {
                return Promise.resolve();
            }
            return new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = 'https://js.stripe.com/v3/';
                script.onload = resolve;
                script.onerror = () => reject(new Error('加载 Stripe.js 失败'));
                document.head.appendChild(script);
            });
        },
        handleQueryOrderStatusResponse(response) {
            if (response.code === 0) {
                this.handlePaymentSuccess();
            } else {
                this.$message.error('订单查询失败，请重试');
            }
        },
        async checkPayment(orderNo) {
            return await api_query_order_status(orderNo);
        },
        handlePaymentSuccess() {
            this.paymentCompleted = true;
            this.$router.push('/payment-success');
        },
        handlePaymentTimeout() {
            this.$message.warning('支付超时，请重新发起购买');
            this.$router.push("/subscriptions")
        }
    }
}
</script>

<style scoped>
.checkout-page {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    padding: 20px;
}

.checkout-panel {
    background: white;
    border-radius: 15px;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 800px;
    height: 96vh;
    /* max-height: 800px; */
    display: flex;
    flex-direction: column;
    position: relative;
}

.back-btn {
    position: absolute;
    top: 2px;
    left: 15px;
    width: 40px;
    height: 40px;
    background: rgba(255, 255, 255, 0.9);
    border: none;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transition: all 0.3s ease;
    color: #667eea;
    z-index: 1000;
}

.back-btn:hover {
    background: white;
    transform: scale(1.1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
}

.back-btn:active {
    transform: scale(0.95);
}

.scrollable-content {
    flex: 1;
    overflow-y: auto;
    padding: 15px 10px 10px 10px; /* 顶部留出返回按钮空间 */
    padding-bottom: 100px; /* 底部留出固定按钮空间 */
}

.section-title {
    width: 100%;
    text-align: center;
    font-size: 16px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 10px;
    border-bottom: 2px solid #667eea;
    padding-bottom: 10px;
}

.price-display {
    background: linear-gradient(45deg, #667eea, #764ba2);
    color: white;
    padding: 15px;
    border-radius: 10px;
    text-align: center;
    margin: 20px 0;
}

.price-amount {
    font-size: 22px;
    font-weight: bold;
    margin-top: 5px;
}

.personal-info {
    margin: 20px 10px;
}

.product-title {
    font-size: 16px;
    font-weight: bold;
    color: #2c3e50;
    margin-bottom: 10px;
}

.feature-list {
    list-style: none;
    margin-bottom: 10px;
    padding: 0;
}

.feature-list li {
    padding: 5px 0;
    border-bottom: 1px solid #eee;
    position: relative;
    padding-left: 25px;
    font-size: 14px;
}

.feature-list li::before {
    content: '✓';
    position: absolute;
    left: 0;
    color: #27ae60;
    font-weight: bold;
}

.loading {
    text-align: center;
    padding: 50px 0;
}

.spinner {
    border: 4px solid #f3f3f3;
    border-top: 4px solid #667eea;
    border-radius: 50%;
    width: 50px;
    height: 50px;
    animation: spin 1s linear infinite;
    margin: 0 auto 20px;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* 固定底部样式 */
.fixed-bottom {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background: white;
    border-top: 1px solid #eee;
    border-radius: 0 0 15px 15px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.confirm-section {
    padding: 20px;
}

.confirm-text {
    text-align: center;
    margin-bottom: 10px;
}

.confirm-text p {
    font-size: 13px;
    color: #666;
    margin: 0;
}

.confirm-btn {
    background: linear-gradient(45deg, #27ae60, #2ecc71);
    color: white;
    border: none;
    padding: 10px 40px;
    border-radius: 25px;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
    width: 100%;
}

.confirm-btn:hover:not(:disabled) {
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(39, 174, 96, 0.4);
}

.confirm-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .checkout-page {
        padding: 10px;
    }
    
    .checkout-panel {
        height: 95vh;
    }
    
    /* .scrollable-content {
        padding: 10px 15px 15px 15px;
        padding-bottom: 120px;
    } */
    
    .confirm-section {
        padding: 10px;
    }
    
    .back-btn {
        width: 35px;
        height: 35px;
        top: 5px;
        left: 10px;
    }
}
</style>